import { getItemsFromCollection } from "directus/src/operations";

export async function fetchProjectsForTimesheetLog(search = "") {
  try {
    const query = {
      fields: ["id", "name"],
      filter: {
        status: {
          _eq: "active",
        },
        _or: [
          {
            access: {
              employee: {
                user: { _eq: "$CURRENT_USER" },
              },
              role: {
                _in: ["project_coordinator", "job_coordinator", "employee", "milestone_coordinator"]
              },
            }
          }
        ],

      },
      search: search,
      sort: ["name"],
      limit: -1,
    };

    const data = await getItemsFromCollection("projects", query);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
}
